if (!customElements.get('featured-blog-slider')) {
  customElements.define(
    'featured-blog-slider',
    class FeaturedBlogSlider extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector('.featured-blog__items');
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 3;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
        this.navigationPosition = this.dataset.navigationPosition || 'bottom';
        this.sliderInstance = false;

        if (!this.enableSlider || !this.sliderWrapper) return;

        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.classList.add('swiper');
        this.sliderWrapper.classList.remove('f-grid');
        this.sliderWrapper.classList.add('swiper-wrapper');

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          {
            slidesPerView: 2,
            spaceBetween,
            navigation: {
              nextEl: this.section.querySelector('.swiper-button-next'),
              prevEl: this.section.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
              768: { slidesPerView: this.tabletItems },
              1280: { slidesPerView: this.items },
            },
            loop: false,
            threshold: 2,
            watchSlidesProgress: true,
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
          },
          [FoxTheme.Swiper.Mousewheel]
        );
        this.sliderInstance.init();
        this.calcNavButtonsPosition();
      }

      destroySlider() {
        this.classList.remove('swiper');
        this.sliderWrapper.classList.remove('swiper-wrapper');
        this.sliderWrapper.classList.add('f-grid');
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.article-card__media');
        const controls = this.section.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
